<script>
import { Sprite, Container } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene9',
  mixins: [ SceneMixin ],
  beforeDestroy() {
    console.log('beforeDestroy');
    _.each(this.$sprites, (sp, index)=>{
      if(this.$els[index]) this.$els[index]['container'].removeChild(sp)
    })
    this.$container.removeChild(this.$scene)
    this.$sub1.kill()
    this.$sub2.kill()
  },

  created() {

    const sprites = {}
    this.$sprites = sprites

    this.$scene = new Container 
    this.$scene.interactiveChildren = false
    
    this.$container.addChild(this.$scene)
    this.$parent.$scene9 = this.$scene

    const container = new Container()
          container.alpha = 0

    this.setCenterContainer(container)   
    this.$scene.addChild(container)


    const bkg = new Container()
    const front = new Container()
          front.x = -1638
          front.y = 209
          front.scale.set(1.39)

    const over = new Container()

    container.addChild(bkg)
    container.addChild(front)
    container.addChild(over)

    const tl = new TimelineMax()
    this.$sub1 = new TimelineMax()
    this.$sub2 = new TimelineMax()

    const bubbles = []

    const createExBubbleTl = (bubble, delay, py) => {
      const sc = [ 0.25, 0.35, 0.4, 0.3, 0.28 ]
      const tlb = new TimelineMax()
            .set({}, { delay: delay })
            .add([
              TweenMax.to(bubble, tempo*2, { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
              TweenMax.to(bubble, tempo*8, { pixi:{ scale: this.$root.$scale*sc[_.random(0, 4)] }, ease: Elastic.easeOut }),
              TweenMax.to(bubble, tempo*40, { pixi:{ y: '-='+ py }, ease: Linear.easeNone, delay: tempo*4 }), 
            ])
            .add([
              TweenMax.to(bubble, tempo*4, { pixi:{ scale: this.$root.$scale*0.5, y: '-=300' }, ease: Cubic.easeIn }),
              TweenMax.to(bubble, tempo*0.5, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: tempo*2 }),
            ])
      return tlb
    }

    // ******************************************************** //
    // ******************************************************** //


    let swipe = (this.$root.above('tablet')) 
        ? { container: front, alpha: 1, x: -2000, y: 0 }
        : { ref: 'swipe_quart', container: front, alpha: 1, x: -2000, y: 0, scale: 3 }
        
    let swipe1 = (this.$root.above('tablet')) 
        ? { container: front, alpha: 1, x: -2000, y: 0 }
        : { ref: 'swipe1_quart', container: front, alpha: 1, x: -2000, y: 0, scale: 3 }

    let blur_reverse = (this.$root.above('tablet')) 
        ? { container: front, alpha: 1, x: -4350, y: -3800 }
        : { ref: 'blur_reverse_quart', container: front, alpha: 1, x: -4350, y: -3800, scale: 2 }

    let blur = (this.$root.above('tablet')) 
        ? { container: front, alpha: 0, x: -4350, y: -1400 }
        : { ref: 'blur_quart', container: front, alpha: 0, x: -4350, y: -1400, scale: 2 }

    let large = (this.$root.above('tablet')) 
        ? { container: front, alpha: 0, x: 90 }
        : { ref: 'large_quart', container: front, alpha: 0, x: 90, scale: 2 }

    const els = {

      'front': { container: bkg, alpha: 1, ref: 'front_s9' },
      'bg': { container: bkg, alpha: 0, ref: 'white' },

      'large': large,
      'bancs': { container: front, alpha: 1, x: -50, y: 254, ref: 'bancs_50',  scale: 1 },
     
      'blur_reverse': blur_reverse,
      'blur': blur,

      'suspension1': { container: front, alpha: 0, x: -4345, y: -2000, scale: this.$root.$scale * 1.25 },
      'suspension2': { container: front, alpha: 0, x: -4250, y: -2590, scale: this.$root.$scale * 1.20 },
      'suspension3': { container: front, alpha: 0, x: -4495, y: -2490, scale: this.$root.$scale * 1.25 },
      'suspension4': { container: front, alpha: 0, x: -4350, y: -3150, scale: this.$root.$scale * 1.40 },
      'suspension5': { container: front, alpha: 0, x: -4475, y: -3850, scale: this.$root.$scale * 1.25 },
      'suspension6': { ref: 'suspension1', container: front, alpha: 0, x: -4175, y: -3750, scale: this.$root.$scale },

      'b4_1': { container: front, alpha: 1, x: -1420, y: -30, ref: 'b4_50', scale: 1 },
      'b4_2': { container: front, alpha: 1, x: -2305, y: -38, ref: 'b4_50', scale: 1 },
      'b4_3': { container: front, alpha: 1, x: -3180, y: -38, ref: 'b4_50', scale: 1 },
      'b4_4': { container: front, alpha: 1, x: -4300, y: -38, ref: 'b41_50', scale: 1 },

      'b3_1': { container: front, alpha: 1, x: -1356, y: 0, ref: 'b3_50', scale: 1 },
      'b3_2': { container: front, alpha: 1, x: -2306, y: 0, ref: 'b3_50', scale: 1 },
      'b3_3': { container: front, alpha: 1, x: -3245, y: 0, ref: 'b3_50', scale: 1 },
      'b3_4': { container: front, alpha: 1, x: -4345, y: 0, ref: 'b31_50', scale: 1 },

      'bubble_81': { container: front, alpha: 0, x: -3390, y: -340, scale: this.$root.$scale * .1, ref: 'bb2' },
      'bubble_2': { container: front, alpha: 0, x: -50, y: -200, scale: this.$root.$scale * .1, ref: 'bb2' },
      'bubble_3': { container: front, alpha: 0, x: -200, y: -300, scale: this.$root.$scale * .1, ref: 'bb2' },

      'bubble_12': { container: front, alpha: 0, x: -4490, y: -250, scale: this.$root.$scale * .1, ref: 'bb3', is_bubble: { delay: 1.260, y: 2000 }},
      'bubble_13': { container: front, alpha: 0, x: -4160, y: -320, scale: this.$root.$scale * .1, ref: 'bb3', is_bubble: { delay: 1.270, y: 2200 }},
      'bubble_18': { container: front, alpha: 0, x: -4194, y: -450, scale: this.$root.$scale * .1, ref: 'bb2', is_bubble: { delay: 1.400, y: 2600 }},
      'bubble_19': { container: front, alpha: 0, x: -4490, y: -400, scale: this.$root.$scale * .1, ref: 'bb1', is_bubble: { delay: 1.500, y: 1700 }},

      'b2_1': { container: front, alpha: 1, x: -1319, y: 94, ref: 'b2_50', scale: 1 },
      'b2_2': { container: front, alpha: 1, x: -2305, y: 94, ref: 'b2_50', scale: 1 },
      'b2_3': { container: front, alpha: 1, x: -3285, y: 94, ref: 'b2_50', scale: 1 },
      'b2_4': { container: front, alpha: 1, x: -4330, y: 94, ref: 'b2_50', scale: 1 },

      'bubble_5': { container: front, alpha: 0, x: -1470, y: -250, scale: this.$root.$scale * .1, ref: 'bb1' },
      'bubble_6': { container: front, alpha: 0, x: -2147, y: -280, scale: this.$root.$scale * .1, ref: 'bb1' },
      'bubble_8': { container: front, alpha: 0, x: -3110, y: -200, scale: this.$root.$scale * .1, ref: 'bb1' },
      'bubble_11': { container: front, alpha: 0, x: -4480, y: -300, scale: this.$root.$scale * .1, ref: 'bb2', is_bubble: { delay: 1.220, y: 2500 }},
      'bubble_14': { container: front, alpha: 0, x: -4160, y: -250, scale: this.$root.$scale * .1, ref: 'bb2', is_bubble: { delay: 1.280, y: 2000 }},

      'bubble_17': { container: front, alpha: 0, x: -4140, y: -320, scale: this.$root.$scale * .1, ref: 'bb2', is_bubble: { delay: 1.380, y: 2100 }},
      'bubble_25': { container: front, alpha: 0, x: -4540, y: -200, scale: this.$root.$scale * .1, ref: 'bb1', is_bubble: { delay: 1.750, y: 2800 }},
      'bubble_27': { container: front, alpha: 0, x: -4140, y: -320, scale: this.$root.$scale * .1, ref: 'bb2', is_bubble: { delay: 1.900, y: 2100 }},  
      'bubble_29': { container: front, alpha: 0, x: -4500, y: -400, scale: this.$root.$scale * .1, ref: 'bb1', is_bubble: { delay: 2.000, y: 1700 }},

      'b11': { container: front, alpha: 1, x: -1274, y: 244, ref: 'b11_50', scale: 1 },
      'b12': { container: front, alpha: 1, x: -2300, y: 244, ref: 'b12_50', scale: 1 },
      'b13': { container: front, alpha: 1, x: -3325, y: 244, ref: 'b13_50', scale: 1 },
      'b14': { container: front, alpha: 1, x: -4350, y: 244, ref: 'b14_50', scale: 1 },

      'swipe': swipe,
      'swipe1': swipe1,

      'bubble_1': { container: front, alpha: 0, x: 378, y: -200, scale: this.$root.$scale * 0.1, ref: 'bb1' },
      'bubble_4': { container: front, alpha: 0, x: -1080, y: -320, scale: this.$root.$scale * .1, ref: 'bb1' },
      'bubble_7': { container: front, alpha: 0, x: -2510, y: -40, scale: this.$root.$scale * .1, ref: 'bb1' },
      'bubble_82': { container: front, alpha: 0, x: -3510, y: -20, scale: this.$root.$scale * .1, ref: 'bb1' },

      'bubble_9': { container: front, alpha: 0, x: -4554, y: -150, scale: this.$root.$scale * .1, ref: 'bb1', is_bubble: { delay: 1.165, y: 2100  }},
      'bubble_10': { container: front, alpha: 0, x: -4140, y: -100, scale: this.$root.$scale * .1, ref: 'bb1', is_bubble: { delay: 1.180, y: 2000 }},
      'bubble_15': { container: front, alpha: 0, x: -4480, y: -400, scale: this.$root.$scale * .1, ref: 'bb2', is_bubble: { delay: 1.320, y: 1800 }},
      'bubble_34': { container: front, alpha: 0, x: -4150, y: -400, scale: this.$root.$scale * .1, ref: 'bb2', is_bubble: { delay: 1.670, y: 2000 }},
      'bubble_35': { container: front, alpha: 0, x: -4180, y: -400, scale: this.$root.$scale * .1, ref: 'bb1', is_bubble: { delay: 1.800, y: 1800 }},

      'bubble_27': { container: front, alpha: 0, x: -4190, y: -1320, scale: this.$root.$scale * .1, ref: 'bb1', is_bubble: { delay: 2.300, y: 2500 }},  
      'bubble_28': { container: front, alpha: 0, x: -4100, y: -1500, scale: this.$root.$scale * .1, ref: 'bb2', is_bubble: { delay: 2.280, y: 1600 }},
      'bubble_29': { container: front, alpha: 0, x: -4400, y: -1400, scale: this.$root.$scale * .1, ref: 'bb2', is_bubble: { delay: 2.400, y: 1250 }},
      'bubble_40': { container: front, alpha: 0, x: -4280, y: -1800, scale: this.$root.$scale * .1, ref: 'bb2', is_bubble: { delay: 2.500, y: 2250 }},
      'bubble_40': { container: front, alpha: 0, x: -4250, y: -2500, scale: this.$root.$scale * .1, ref: 'bb1', is_bubble: { delay: 3.000, y: 1250 }},
      'bubble_41': { container: front, alpha: 0, x: -4600, y: -2850, scale: this.$root.$scale * .1, ref: 'bb2', is_bubble: { delay: 3.100, y: 1950 }},
      'bubble_42': { container: front, alpha: 0, x: -4350, y: -3050, scale: this.$root.$scale * .1, ref: 'bb1', is_bubble: { delay: 3.300, y: 1200 }},
      'bubble_43': { container: front, alpha: 0, x: -4495, y: -1900, scale: this.$root.$scale * .1, ref: 'bb1', is_bubble: { delay: 2.600, y: 750 }},
      'bubble_44': { container: front, alpha: 0, x: -4100, y: -2000, scale: this.$root.$scale * .1, ref: 'bb2', is_bubble: { delay: 2.900, y: 1350 }},
      
      'speaker': { container: front, alpha: 1, x: 1178, y: -192, ref: 'speaker_large' },
    }

    _.each(els, (el, name)=>{
      const _name = (el.ref) ? el.ref : name
      const sprite = new Sprite.from(this.$resources[_name].texture) 
            sprite.scale.set(this.$root.$scale)
            sprite.anchor.set(.5)
            sprite.alpha = el.alpha
      el.container.addChild(sprite)
      sprites[name] = sprite
      if(el.is_bubble) {
        const tml = createExBubbleTl(sprites[name], appear*el.is_bubble.delay, el.is_bubble.y)
        bubbles.push(tml)
      }
      this.applySettings(sprite, el)
    })

    this.$els = els

    // ******************************************************** //
    // ******************************************************** //

    const createBubbleTl = (bubble, delay, ref) => {
      const py = [ 450, 500, 600, 700, 800, 900 ]
      const sc = [ 0.25, 0.35, 0.4, 0.3, 0.28 ]
      const tlb = new TimelineMax()
            .set({}, { delay: delay })
            .add([
              TweenMax.to(bubble, tempo*2, { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
              TweenMax.to(bubble, tempo*8, { pixi:{ scale: this.$root.$scale*sc[_.random(0, 4)] }, ease: Elastic.easeOut }),
              TweenMax.to(bubble, tempo*10, { pixi:{ y: '-='+ py[_.random(0, 5)] }, ease: Cubic.easeIn }), 
              TweenMax.to(bubble, tempo*10, { pixi:{ x: '+=50' }, ease: Cubic.easeIn })
            ])
            .add([
              TweenMax.to(bubble, tempo*4, { pixi:{ scale: this.$root.$scale*0.5 }, ease: Elastic.easeOut }),
              TweenMax.to(bubble, tempo*0.5, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: tempo*2 }),
            ])
      return tlb
    }

    const createBuddyTl = (buddy, delay, _alpha) => {
      const alpha = (_alpha == undefined) ? 1 : _alpha
      const sc = [ 0.25, 0.5, 0.4, 0.3, 0.10 ]
      const parallax =  [ 200, 500, 300, 400 ]
      const tml = new TimelineMax()
            .set({}, { delay: delay })
            .add([
              TweenMax.to(buddy, 20*.065, { pixi:{ alpha: alpha }, ease: Linear.easeNone }),
              TweenMax.to(buddy, 20*.065, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: 60*.065 }),
              TweenMax.to(buddy, 100*.065, { pixi:{ y: '+='+ parallax[_.random(3)] }, ease: Power2.easeOut })
            ])
      return tml
    }

    // ******************************************************** //
    // ******************************************************** //

    const tempo = .5
    const appear = 37.8
    // const alphaFilter = new PIXI.filters.AlphaFilter(0.0)
    // container.filters = [ alphaFilter ]


    this.$sub1
      .add([
        // TweenMax.to(alphaFilter, 1, { alpha: 1, ease: Linear.easeNone, onComplete: ()=>{ container.filters = null } }),
        TweenMax.to(container, 1, { alpha: 1, ease: Linear.easeNone }),
        TweenMax.to(sprites['large'], appear*0.05, { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
      ])
      .add([
        TweenMax.to(sprites['bg'], appear*0.05, { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['front'], appear*0.05, { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
        TweenMax.to(front, appear*0.1, { pixi:{ scale: 1, y: -28, x: -1174 }, ease: Cubic.easeIn }),
      ])
      .add([

        TweenMax.to(front, appear*1, { pixi:{ y: -28, x: 4350 }, ease: Linear.easeOut }),
        TweenMax.from(sprites['bancs'], appear*0.10, { pixi:{ x: '-=100' }, ease: Linear.easeNone, delay: appear*0.05 }),

        TweenMax.from(sprites['b11'], appear*0.20, { pixi:{ y: '+=100' }, ease: Cubic.easeOut, delay: 10 }),

        TweenMax.from(sprites['b2_1'], appear*0.10, { pixi:{ alpha: 0, scale: this.$root.$scale*0.7 }, ease: Cubic.easeOut, delay: 11 }),
        TweenMax.from(sprites['b3_1'], appear*0.05, { pixi:{ alpha: 0, scale: this.$root.$scale*0.7 }, ease: Cubic.easeOut, delay: 12 }),
        TweenMax.from(sprites['b4_1'], appear*0.05, { pixi:{ alpha: 0, scale: this.$root.$scale*0.7 }, ease: Linear.easeNone, delay: 13 }),

        TweenMax.from(sprites['b12'], appear*0.20, { pixi:{ y: '+=100' }, ease: Cubic.easeOut, delay: 16.5 }),

        TweenMax.from(sprites['b2_2'], appear*0.10, { pixi:{ alpha: 0, scale: this.$root.$scale*0.7 }, ease: Cubic.easeOut, delay: 17.5 }),
        TweenMax.from(sprites['b3_2'], appear*0.05, { pixi:{ alpha: 0, scale: this.$root.$scale*0.7 }, ease: Cubic.easeOut, delay: 18.5}),
        TweenMax.from(sprites['b4_2'], appear*0.05, { pixi:{ alpha: 0, scale: this.$root.$scale*0.7 }, ease: Linear.easeNone, delay: 19.5 }),

        TweenMax.from(sprites['b13'], appear*0.20, { pixi:{ y: '+=100' }, ease: Cubic.easeOut, delay: 22 }),

        TweenMax.from(sprites['b2_3'], appear*0.10, { pixi:{ alpha: 0, scale: this.$root.$scale*0.7 }, ease: Cubic.easeOut, delay: 23 }),
        TweenMax.from(sprites['b3_3'], appear*0.05, { pixi:{ alpha: 0, scale: this.$root.$scale*0.7 }, ease: Cubic.easeOut, delay: 24 }),
        TweenMax.from(sprites['b4_3'], appear*0.05, { pixi:{ alpha: 0, scale: this.$root.$scale*0.7 }, ease: Linear.easeNone, delay: 25 }),

        TweenMax.from(sprites['b14'], appear*0.20, { pixi:{ y: '+=100' }, ease: Cubic.easeOut, delay: 29 }),

        TweenMax.from(sprites['b2_4'], appear*0.10, { pixi:{ alpha: 0, scale: this.$root.$scale*0.7 }, ease: Cubic.easeOut, delay: 30 }),
        TweenMax.from(sprites['b3_4'], appear*0.05, { pixi:{ alpha: 0, scale: this.$root.$scale*0.7 }, ease: Cubic.easeOut, delay: 31 }),
        TweenMax.from(sprites['b4_4'], appear*0.10, { pixi:{ alpha: 0, scale: this.$root.$scale*0.7 }, ease: Linear.easeNone, delay: 32 }),

        createBubbleTl(sprites.bubble_1, 2.25),
        createBubbleTl(sprites.bubble_2, 3.8),
        createBubbleTl(sprites.bubble_3, 6),

        createBubbleTl(sprites.bubble_4, 13),
        createBubbleTl(sprites.bubble_5, 15),
        createBubbleTl(sprites.bubble_6, 20),
        createBubbleTl(sprites.bubble_7, 22),

        createBubbleTl(sprites.bubble_8, 26),
        createBubbleTl(sprites.bubble_81, 28),
        createBubbleTl(sprites.bubble_82, 30),
      ])

    .add([

      TweenMax.to(front, 31, { pixi:{ y: '+=3800' }, ease: Linear.easeNone, delay: 0 }), 
      TweenMax.to(sprites['b4_4'], 12, { pixi:{ y: '-=1000', x: '-=40' }, ease: Linear.easeNone, delay: 0 }),
      TweenMax.to(sprites['b3_4'], 10, { pixi:{ y: '-=575' }, ease: Linear.easeNone, delay: 0 }),
      TweenMax.to(sprites['b2_4'], 5, { pixi:{ y: '-=150' }, ease: Linear.easeNone, delay: 0 }),
      TweenMax.to(sprites['blur'], 20*.05, { pixi:{ alpha: 1 }, ease: Linear.easeNone, delay: 0 }),
      TweenMax.to(sprites['b3_4'], 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: 9 }),
      TweenMax.to(sprites['b4_4'], 1, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: 11 }),

      createBuddyTl(sprites['suspension1'], 11),
      createBuddyTl(sprites['suspension2'], 325*.054),
      createBuddyTl(sprites['suspension3'], 300*.054),
      createBuddyTl(sprites['suspension4'], 380*.058, .65),
      createBuddyTl(sprites['suspension5'], 450*.058, .50),
      createBuddyTl(sprites['suspension6'], 440*.058, .25),

    ])

    this.$sub2.add(bubbles)
    this.$tl.add([ this.$sub1, this.$sub2 ], 75.5)

  },
  mounted() {

    // console.log('Scene9');
    // this.$parent.chapter.$tl.seek(70)
    
  }
}
</script>























